/**
 * API base config + tipos compartidos.
 * En producción todas las llamadas pasan por nginx /api/ → http://api:8000/.
 * En dev, vite proxy reenvía /api a localhost:8000.
 */

export const API_BASE = '/api'

export interface DeviceCreds {
  device_id: string
  device_token: string
}

export class ApiError extends Error {
  constructor(public status: number, message: string) {
    super(message)
    this.name = 'ApiError'
  }
}
